import BaseService from "@/boot/BaseService";
class CondicionPagoService extends BaseService {
  constructor() {
    super(null, "/condicion-pago");
  }
  async index() {
    return await this.get("/");
  }
}

export default new CondicionPagoService();
